<template>
  <v-footer>
    <div class="flex-1-0-100 text-center mt-2" style="font-size: smaller;">
      &copy;{{ (nowYear > appConfig.copy.establishYear ? `${appConfig.copy.establishYear} — ` : '') + nowYear }} {{
        appConfig.copy.runByName }}
      <p style="font-size: x-small;">
        このサイトは reCAPTCHA によって保護されており、Googleの
        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a> と
        <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">利用規約</a> が適用されます。
      </p>
    </div>
  </v-footer>
</template>
<script setup lang="ts">
const appConfig = useAppConfig();
const nowYear = new Date().getFullYear();
</script>